import gameIds from 'a/hub/data/GameIds';
import { getMockedUsageData } from 'lib/browserStorage';
import { API_REQUEST_STATUS, PRODUCT_LECTURA, PRODUCT_READING } from 'lib/constants';

import { persistStateTypes } from './persistStateReducer';

export const USAGE_ACTION_TYPES = {
  GET_USAGE_REQUEST: 'GET_USAGE_REQUEST',
  GET_USAGE_SUCCESS: 'GET_USAGE_SUCCESS',
  GET_USAGE_ERROR: 'GET_USAGE_ERROR',
  GET_USAGE_TARGETS_REQUEST: 'GET_USAGE_TARGETS_REQUEST',
  GET_USAGE_TARGETS_SUCCESS: 'GET_USAGE_TARGETS_SUCCESS',
  GET_USAGE_TARGETS_ERROR: 'GET_USAGE_TARGETS_ERROR',
  MARK_USAGE_PROGRESS_SEEN: 'MARK_USAGE_PROGRESS_SEEN',
};

const productInitialState = {
  status: API_REQUEST_STATUS.IDLE,
  weekKey: null,
  weeklyUsageTime: null, // minutes
  lastShownUsageTime: 0, // minutes
  lastFetchedAt: null,
};

// weekly usage target from content-api; shared by both products, so it sits outside the product entries
const targetInitialState = {
  status: API_REQUEST_STATUS.IDLE,
  weeklyTarget: null, // minutes; null when unavailable for the student's grade
};

const initialState = {
  [PRODUCT_READING]: { ...productInitialState },
  [PRODUCT_LECTURA]: { ...productInitialState },
  target: { ...targetInitialState },
};

export default (state = initialState, { type, payload = {}, stateData }) => {
  switch (type) {
    case USAGE_ACTION_TYPES.GET_USAGE_REQUEST:
      return {
        ...state,
        [payload.product]: {
          ...state[payload.product],
          weekKey: payload.startDate,
          status: API_REQUEST_STATUS.LOADING,
        },
      };
    case USAGE_ACTION_TYPES.GET_USAGE_SUCCESS:
      return {
        ...state,
        [payload.product]: {
          ...state[payload.product],
          status: API_REQUEST_STATUS.SUCCESS,
          weeklyUsageTime: payload.time,
          lastFetchedAt: Date.now(),
        },
      };
    case USAGE_ACTION_TYPES.GET_USAGE_ERROR:
      return {
        ...state,
        [payload.product]: {
          ...state[payload.product],
          status: API_REQUEST_STATUS.ERROR,
          weeklyUsageTime: null,
          lastFetchedAt: null,
        },
      };

    case USAGE_ACTION_TYPES.GET_USAGE_TARGETS_REQUEST:
      return {
        ...state,
        target: { ...state.target, status: API_REQUEST_STATUS.LOADING },
      };
    case USAGE_ACTION_TYPES.GET_USAGE_TARGETS_SUCCESS:
      return {
        ...state,
        target: {
          ...state.target,
          status: API_REQUEST_STATUS.SUCCESS,
          weeklyTarget: payload.weeklyTarget ?? null,
        },
      };
    case USAGE_ACTION_TYPES.GET_USAGE_TARGETS_ERROR:
      return {
        ...state,
        target: { ...state.target, status: API_REQUEST_STATUS.ERROR, weeklyTarget: null },
      };

    case persistStateTypes.REQUESTRESPONSE_GAMESTATE_ALL: {
      let { weeklyUsage: savedData } = ((stateData?.[gameIds.METAGAME_USAGE] || {}).GameData || {}).gameDetails || {};
      const mockData = getMockedUsageData();
      if (mockData) {
        savedData = mockData;
      }
      if (savedData) {
        return Object.entries(savedData).reduce((acc, [product, data]) => {
          const productState = state[product] || {};
          const key = productState.weekKey;
          if (!key) {
            return acc;
          }
          const weekData = (mockData ? data : data[key]) || {};
          const lastShownUsageTime = weekData.lastShownUsageTime ?? productState.lastShownUsageTime;
          return {
            ...acc,
            [product]: {
              ...productState,
              lastShownUsageTime,
            },
          };
        }, state);
      }
      return state;
    }
    case persistStateTypes.REQUESTERROR_GAMESTATE: {
      return state;
    }
    case USAGE_ACTION_TYPES.MARK_USAGE_PROGRESS_SEEN: {
      const { product, lastShownUsageTime } = payload;
      return {
        ...state,
        [product]: {
          ...state[product],
          lastShownUsageTime,
        },
      };
    }
    default:
      return state;
  }
};
